export default "__VITE_ASSET__e8741b4e__"